module.exports = __webpack_public_path__ + "static/media/logo.9b2a02ef.svg";